/** The long side, in pixels, a photograph is shrunk to before it is sent. The
 *  issuer keeps 48×64 of it; this only spares the upload a 12-megapixel file. */
export const UPLOAD_LONG_SIDE = 800;

/**
 * A picture the person chose, as a JPEG no larger than `UPLOAD_LONG_SIDE` on
 * its long side. `createImageBitmap` applies the EXIF orientation, so the face
 * arrives upright; the issuer would turn it too, but the canvas drops the tag.
 * Rejects on a file the browser cannot decode.
 */
export async function shrinkPicture(file: Blob, longSide = UPLOAD_LONG_SIDE): Promise<Uint8Array> {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, longSide / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(bitmap.width * scale));
  canvas.height = Math.max(1, Math.round(bitmap.height * scale));
  canvas.getContext("2d")!.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();
  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob(resolve, "image/jpeg", 0.85));
  if (!blob) throw new Error("the browser would not encode the picture");
  return new Uint8Array(await blob.arrayBuffer());
}
